import { Component, Input } from '@angular/core'
import { HelperService } from '../../../../../services/helper.service'
import { IDataCardBFGI } from '../../../../../models/data-card.model'
import { NotificationsDataCardModalComponent } from '../../cmms-components/notifications-data-card-modal/notifications-data-card-modal.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-data-binary-fg-ini',
    templateUrl: './data-binary-fg-ini.component.html',
    standalone: false
})
export class DataBinaryFgIniComponent {
  @Input() data: IDataCardBFGI
  @Input() filter?: {startTime?: string; endTime?: string}
  @Input() hasCMMSPackage: boolean = false
  @Input() hasRCAFPackage: boolean = false

  constructor(private modalService: NgbModal) {}

  public getSIFParams(mo: string): any {
    return {
      filter: JSON.stringify(
        HelperService.getObjectWithoutNullValues({
          initiators: mo,
        }),
      ),
    }
  }

  public onOpenNotificationModal(tag: string): void {
    const modalRef = this.modalService.open(NotificationsDataCardModalComponent, {
      windowClass: 'cmms-notification-modal-z2000',
      backdropClass: 'cmms-notification-backdrop-z2000',
    })
    modalRef.componentInstance.mainObject = tag
  }

  public displayNotificationIcon(notificationStatus?: number): boolean {
    return this.hasCMMSPackage && (notificationStatus === -1 || notificationStatus === 1)
  }

  public hasUrlBadges(): boolean {
    return !!(
      this.data &&
      (this.data.Dev_Active ||
        this.data.Dev_InActive_Count ||
        this.data.Flt_Active ||
        this.data.Flt_InActive_Count ||
        this.data.Dmd_Active ||
        this.data.Dmd_InActive_Count ||
        this.data.Ovr_Active ||
        this.data.Ovr_InActive_Count)
    )
  }
}
